import { render, staticRenderFns } from "./VTailwindModal.vue?vue&type=template&id=5ed49365&"
import script from "./VTailwindModal.vue?vue&type=script&lang=ts&"
export * from "./VTailwindModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports